import {
    REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_REQUESTED,
    REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_SUCCEEDED,
    REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_FAILED,
    REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_REQUESTED,
    REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_SUCCEEDED,
    REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_FAILED,
    REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_CANCELED,
    REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_REQUESTED,
    REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_SUCCEEDED,
    REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_FAILED,
    REPORTS_HARVEST_TIMESHEETS_ALL_SET,
    REPORTS_HARVEST_TIMESHEETS_ALL_MERGE,
    REPORTS_HARVEST_TIMESHEET_SET
} from './constants';

export function requestloadReportsHarvestTimesheetsAll() {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_REQUESTED
    };
}

export function succeededLoadReportsHarvestTimesheetsAll(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadReportsHarvestTimesheetsAll(error: Error) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestPollingReportsHarvestTimesheetsAll() {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_REQUESTED
    };
}

export function succeededPollingReportsHarvestTimesheetsAll(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingReportsHarvestTimesheetsAll(error: Error) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingReportsHarvestTimesheetsAll() {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_CANCELED
    };
}

export function requestExportReportsHarvestTimesheetsAll() {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_REQUESTED
    };
}

export function succeededExportReportsHarvestTimesheetsAll(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_SUCCEEDED,
        payload: response
    };
}

export function failedExportReportsHarvestTimesheetsAll(error: Error) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_FAILED,
        payload: error,
        error: true
    };
}

export function setReportsHarvestTimesheetsAll(data: Record<string, any>[]) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_SET,
        payload: data,
        meta: {
            // TODO create meaningful composite key
            keyBy: 'todo'
        }
    };
}

export function mergeReportsHarvestTimesheetsAll(data: Record<string, any>[]) {
    return {
        type: REPORTS_HARVEST_TIMESHEETS_ALL_MERGE,
        payload: data
    };
}

export function setReportsHarvestTimesheet(data: Record<string, any>) {
    return {
        type: REPORTS_HARVEST_TIMESHEET_SET,
        payload: data
    };
}
